import { render, staticRenderFns } from "./verification.vue?vue&type=template&id=3184357e&scoped=true&"
import script from "./verification.vue?vue&type=script&lang=js&"
export * from "./verification.vue?vue&type=script&lang=js&"
import style0 from "./verification.vue?vue&type=style&index=0&id=3184357e&lang=scss&scoped=true&"
import style1 from "./verification.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3184357e",
  null
  
)

export default component.exports